<template>
  <v-form v-model="form_valido" ref="form" lazy-validation>
    <z-dialogo ref="dialogo" titulo="Agendamento Produto" :dividers="true" largura="800px" altura="300px" scrollable persistent>

      <template #prepend>
        <div class="py-2 px-4">
            <v-card flat color="grey lighten-4" class="rounded-lg">
              <v-card-text class="text-primary" style="border: 1px solid #ccc;">
                <div class="d-flex justify-space-between">
                  <span class="font-weight-bold">Pedido:</span>
                  <span>{{ pedido.id }}</span>
                </div>
                <div class="d-flex justify-space-between">
                  <span class="font-weight-bold">Data:</span>
                  <span>{{ pedido.data_emissao | dataBR }}</span>
                </div>
                <div class="d-flex justify-space-between">
                  <span class="font-weight-bold">Fornecedor:</span>
                  <span class="font-weight-bold">{{ pedido.fornecedor_id }} - {{ pedido?.fornecedor?.razao }}</span>
                </div>
                <div class="d-flex justify-space-between">
                  <span class="font-weight-bold">Itens:</span>
                  <span>{{ pedido.itens_count }}</span>
                </div>
                <div class="d-flex justify-space-between">
                  <span class="font-weight-bold">Status:</span>
                  <span>
                    <v-chip
                      small
                      dark
                      :color="corChip(pedido.status)"
                    >{{ pedido.status }}</v-chip>
                  </span>
                </div>
              </v-card-text>
            </v-card>
        </div class="pa-4">
      </template>

      <template #conteudo>

        <v-row dense>
          <v-col cols="12" sm="12">

            <v-data-table
              v-model="selected"
              hide-default-footer 
              disable-pagination
              disable-sort
              dense
              item-key="id" 
              :headers="headers_itens" 
              :items="pedido.itens"
              show-select
              @click:row="selecionarItem"
              style="cursor: pointer"
            >
            
              <template #item.index="{ index }">
                {{ index + 1 }}
              </template>

              <template #item.quantidade="{ item }">
                {{ item.quantidade | valorQTD(config.configuracoes.CASAS_DECIMAIS_QUANTIDADE) }} {{ item.unidade }}
              </template>

              <template #item.quantidade_entregue="{ item }">
                {{ item.quantidade_entregue | valorQTD(config.configuracoes.CASAS_DECIMAIS_QUANTIDADE) }} {{ item.unidade }}
              </template>


              <template #item.opcoes="{ item }">
                <v-btn v-if="item?.agendamento?.length > 0" icon tabindex="-1" @click.stop="$refs.dialogoExibirAgendamento.abrir(item)">
                  <v-icon>mdi-calendar</v-icon>
                </v-btn>
              </template>

            </v-data-table>
          </v-col>
        </v-row>

      </template>
      
      <template #actions_right>
        <v-btn text @click="dialogo.fechar()">
          Cancelar
        </v-btn>
        <v-btn depressed color="primary" @click="selecionarProdutos">
          Selecionar
        </v-btn>
      </template>

      <DialogoExibirAgendamento 
        ref="dialogoExibirAgendamento"
      ></DialogoExibirAgendamento>
    </z-dialogo>

  </v-form>
</template>

<script setup>
import { ref, getCurrentInstance, inject } from 'vue';
import { useConfigStore } from '@/app/store/pinia/configuracoes';
import DialogoExibirAgendamento from '@/pages/produtos/controle/DialogoExibirAgendamento.vue';

const emit = defineEmits(['onSelecionarProdutos']);

const { proxy } = getCurrentInstance();
const $notificacao = inject('notificacao');

const config = useConfigStore();

const dialogo = ref(null);
const form = ref(null);
const form_valido = ref(true);
const pedido = ref({});
const selected = ref([]); // Itens selecionados na tabela
const dialogoExibirAgendamento = ref(null);

const headers_itens = ref([
  { text: "Item", value: "index", width: "80px" },
  { text: "Referência", value: "referencia", width: "110px" },
  { text: "Descrição", value: "produto.descricao", sortable: false },
  { text: "Quantidade", value: "quantidade", align: "right" },
  { text: "Recebido", value: "quantidade_entregue", align: "right" },
  { text: "", value: "opcoes", align: "center" },
])

function abrir(pedido_compra) {
  selected.value = [];
  pedido.value = pedido_compra;
  dialogo.value.abrir();
}

function fechar() {
  dialogo.value.fechar();
}

function selecionarProdutos() {
  if (selected.value.length === 0) {
    $notificacao.notificar("Selecione ao menos um produto.");
    return;
  }

  pedido.value.itens_selecionados = selected.value;
  emit('onSelecionarProdutos', pedido.value);
  fechar();
}

function selecionarItem(item,row,$event) {
  row.select(!row.isSelected);
}

function corChip(situacao) {
  const cores = {
    "Pendente": "orange",
    "Parcial": "cyan",
    "Cancelado": "red",
    "Entregue": "green"
  };
  return cores[situacao] || "";
}

defineExpose({
  abrir,
  fechar,
});

</script>

<style lang="scss" scoped>

</style>